import { getItemLocalStorage, hasAccess } from '@utils/helper.utils.js'

const institution = import.meta.env.VITE_INSTITUATION

export const authRoutes = [
  {
    name: 'auth',
    path: '/auth',
    component: () => import('@pages/auth/index.vue'),
    meta: {
      label: 'auth',
      group: 'null',
      user_type: ['*'],
      cust_type: ['*'],
      permissions: ['*'],
      institutions: ['*'],
      icon: '',
    },
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('@pages/auth/login.vue'),
        meta: {
          label: 'Login',
          group: 'null',
          user_type: ['*'],
          cust_type: ['*'],
          permissions: ['*'],
          institutions: ['*'],
          icon: '',
        },
      },
      {
        name: 'sign-up',
        path: 'sign-up',
        component: () => import('@pages/auth/sign-up/index.vue'),
        meta: {
          label: 'SignUp',
          group: 'null',
          user_type: ['*'],
          cust_type: ['*'],
          permissions: ['*'],
          institutions: ['*'],
          icon: '',
        },
      },
      {
        name: 'set-password',
        path: 'set-password',
        props: true,
        component: () => import('@pages/auth/set-password-form.vue'),
        meta: {
          label: 'Set Password',
          group: 'null',
          user_type: ['*'],
          cust_type: ['*'],
          permissions: ['*'],
          institutions: ['*'],
          icon: '',
        },
      },
      {
        name: 'forgot-password',
        path: 'forgot-password',
        props: true,
        component: () => import('@pages/auth/forgot-password/index.vue'),
        meta: {
          label: 'Forgot Password',
          group: 'null',
          user_type: ['*'],
          cust_type: ['*'],
          permissions: ['*'],
          institutions: ['*'],
          icon: '',
        },
      },
      {
        name: 'update-password',
        path: 'update-password',
        props: true,
        component: () => import('@pages/auth/update-password-form.vue'),
        meta: {
          label: 'Update Password',
          group: 'null',
          user_type: ['*'],
          cust_type: ['*'],
          permissions: ['*'],
          institutions: ['*'],
          icon: '',
        },
      },
      {
        name: 'activate-card',
        path: 'activate-card',
        component: () => import('@pages/auth/activate-card/index.vue'),
        meta: {
          label: 'Activate Card',
          group: 'null',
          user_type: ['*'],
          cust_type: ['*'],
          permissions: ['*'],
          institutions: ['*'],
          icon: '',
        },
      },
    ],
  },
]
// Move the menus array to a separate constant
const BASE_MENUS = [
  {
    name: 'reports',
    path: '/reports',
    component: () => import('@pages/reports/Reports.vue'),
    meta: {
      label: 'top_nav.reports',
      group: 'top-nav',
      user_type: ['*'],
      cust_type: ['*'],
      permissions: [
        `CARD_TXNFAILD_RPT`,
        `CLI_TXNFAILD_RPT`,
        'CLI_ANOMLY_RPT',
        'CLI_RUNNING_RPT',
        `CLI_SUMM_RPT`,
        `CLI_CARD_REPORT`,
        'CLI_AUDIT_RPT',
        'CLI_CARD_LIST',
        'CLI_AUTO_TRANSFER_RPT',
        `CARD_SUMM_RPT`,
        `CARD_DETAIL_STMT`,
        'DEAL_SUMMARY_REPORT',
        'DEAL_DETAILED_REPORT',
        'DEAL_STK_PUSH_RPT',
        'CARD_AUDIT_RPT',
        'CARD_ANOMLY_RPT',
        'DEAL_STATION',
        'DEAL_STK_PUSH_RPT',
      ],
      institutions: ['*'],
      icon: '',
    },
  },
  {
    path: '/user-management',
    meta: {
      label: 'top_nav.user_management',
      group: 'top-nav',
      user_type: ['*'],
      cust_type: ['*'],
      permissions: ['CLI_USER_CRT'],
      institutions: ['*'],
      icon: '',
    },
    redirect: '/user-management/users',
    children: [
      {
        name: 'users',
        path: 'users',
        component: () => import('@pages/user-management/Users.vue'),
        meta: {
          label: 'side_nav.users',
          group: 'side-nav',
          user_type: ['*'],
          cust_type: ['*'],
          permissions: ['CLI_USER_CRT'],
          institutions: ['*'],
          icon: '/img/nav/user_management.svg',
        },
      },
      {
        name: 'profiles',
        path: 'profiles',
        component: () => import('@pages/user-management/Profiles.vue'),
        meta: {
          label: 'side_nav.profiles',
          group: 'side-nav',
          user_type: ['*'],
          cust_type: ['*'],
          permissions: ['CLI_USER_CRT'],
          institutions: ['*'],
          icon: '/img/nav/profile.svg',
        },
      },
    ],
  },
  {
    path: '/support',
    component: () => import('@pages/support/index.vue'),
    redirect: '/support/tutorials',
    meta: {
      label: 'top_nav.support',
      group: 'top-nav',
      user_type: ['@CLIENT', '@DEALER'],
      cust_type: ['*'],
      permissions: ['CLI_SUPPORT'],
      institutions: ['*'],
      icon: '',
    },
    children: [
      {
        name: 'tutorials',
        path: '',
        component: () => import('@pages/support/Tutorials.vue'),
        meta: {
          label: 'side_nav.tutorials',
          group: 'side-nav',
          user_type: ['*'],
          cust_type: ['*'],
          permissions: ['*'],
          institutions: ['*'],
          icon: '/img/nav/tutorials.svg',
        },
      },
    ],
  },
  // {
  //   path: '/notifications',
  //   meta: {
  //     label: 'top_nav.notifications',
  //     group: 'top-nav',
  //     user_type: ['*'],
  //     cust_type: ['*'],
  //     permissions: ['CLI_NOTIFICATION'],
  //     institutions: ['*'],
  //     icon: '',
  //   },
  //   children: [
  //     {
  //       name: 'notifications',
  //       path: '',
  //       component: () => import('@pages/notifications/Notifications.vue'),
  //       meta: {
  //         label: 'side_nav.notifications',
  //         group: 'side-nav',
  //         user_type: ['*'],
  //         cust_type: ['*'],
  //         permissions: ['CLI_NOTIFICATION'],
  //         institutions: ['*'],
  //         icon: '/img/nav/notifications.svg',
  //       },
  //     },
  //   ],
  // },
  {
    name: 'dashboard',
    path: '/',
    component: () => import('@pages/dashboard/Dashboard.vue'),
    meta: {
      label: 'sub_nav.dashboard',
      group: 'sub-nav',
      user_type: ['*'],
      cust_type: ['*'],
      permissions: ['*'],
      institutions: ['*'],
      icon: '',
    },
  },
  {
    name: 'home',
    path: '/home',
    meta: {
      label: 'sub_nav.home',
      group: 'sub-nav',
      user_type: ['@CLIENT', '@CARD'],
      cust_type: ['*'],
      permissions: ['*'],
      institutions: ['*'],
      icon: '',
    },
    redirect: '/home/account-info',
    children: [
      {
        name: 'account-info',
        path: 'account-info',
        component: () =>
          import('@pages/home/account-details/AccountDetails.vue'),
        meta: {
          label: 'side_nav.account_info',
          group: 'side-nav',
          user_type: ['*'],
          cust_type: ['*'],
          permissions: ['*'],
          institutions: ['*'],
          icon: '/img/nav/home.svg',
        },
      },
      {
        name: 'station-finder',
        path: 'station-finder',
        component: () => import('@pages/home/station-finder/StationFinder.vue'),
        meta: {
          label: 'side_nav.station_finder',
          group: 'side-nav',
          user_type: ['*'],
          cust_type: ['*'],
          permissions: ['*'],
          institutions: ['*'],
          icon: '/img/nav/station_finder.svg',
        },
      },
      {
        name: 'journey-planner',
        path: 'journey-planner',
        component: () => import('@pages/home/journey-planner/index.vue'),
        meta: {
          label: 'side_nav.journey_planner',
          group: 'side-nav',
          user_type: ['*'],
          cust_type: ['*'],
          permissions: ['*'],
          institutions: ['*'],
          icon: '/img/nav/station_finder.svg',
        },
        redirect: { name: 'journey-plan-table' },
        children: [
          {
            name: 'journey-plan-table',
            path: 'index',
            component: () =>
              import('@pages/home/journey-planner/JourneyPlanTable.vue'),
            meta: {
              label: 'Journey Planner Table',
              user_type: ['*'],
              cust_type: ['*'],
              permissions: ['*'],
              institutions: ['*'],
              icon: '/img/nav/station_finder.svg',
            },
          },
          {
            name: 'view-plan',
            path: 'view-plan',
            component: () =>
              import('@pages/home/journey-planner/JourneyPlanner.vue'),
            meta: {
              label: 'Journey Planner Map',
              user_type: ['*'],
              cust_type: ['*'],
              permissions: ['*'],
              institutions: ['*'],
              icon: '/img/nav/station_finder.svg',
            },
          },
        ],
      },
    ],
  },
  {
    name: 'cards',
    path: '/card',
    meta: {
      label: 'sub_nav.cards',
      group: 'sub-nav',
      user_type: ['@CLIENT', '@CARD'],
      cust_type: ['*'],
      permissions: [
        'CLI_CARD_LIST',
        'CARD_MYCARD',
        'CLI_DEPARTMENT',
        'CLI_DRIVER_CODE',
        'CLI_AUTO_TRANSFER_AUTH',
      ],
      institutions: ['*'],
      icon: '',
    },
    redirect: '/card/list',
    children: [
      {
        name: 'cards_list',
        path: 'list',
        component: () => import('@pages/cards/Cards.vue'),
        meta: {
          label: 'side_nav.card_list',
          group: 'side-nav',
          user_type: ['@CLIENT', '@CARD'],
          cust_type: ['*'],
          permissions: [
            'CLI_CARD_LIST',
            'CARD_MYCARD',
            'CLI_DEPARTMENT',
            'CLI_DRIVER_CODE',
          ],
          institutions: ['*'],
          icon: '/img/nav/card_list.svg',
        },
      },
      {
        name: 'auto_transfer',
        path: 'autoTransfer',
        component: () => import('@pages/cards/AutoTransfer.vue'),
        meta: {
          label: 'side_nav.autoTransfer',
          group: 'side-nav',
          user_type: ['@CLIENT'],
          cust_type: ['Postpaid'],
          permissions: ['CLI_AUTO_TRANSFER'],
          institutions: ['*'],
          icon: '/img/nav/auto_transfer.svg',
        },
      },
      {
        name: 'auto_transfer_auth',
        path: 'autoTransferAuth',
        component: () => import('@pages/cards/AutoTransferAuth.vue'),
        meta: {
          label: 'side_nav.autoTransferAuth',
          group: 'side-nav',
          user_type: ['@CLIENT'],
          cust_type: ['Postpaid'],
          permissions: ['CLI_AUTO_TRANSFER_AUTH'],
          institutions: ['*'],
          icon: '/img/nav/auto_transfer.svg',
        },
      },
      {
        name: 'departments',
        path: 'departments',
        component: () => import('@pages/cards/Departments.vue'),
        meta: {
          label: 'side_nav.departments',
          group: 'side-nav',
          user_type: ['@CLIENT'],
          cust_type: ['*'],
          permissions: ['CLI_DEPARTMENT'],
          institutions: ['*'],
          icon: '/img/nav/departments.svg',
        },
      },
      {
        name: 'driver-codes',
        path: 'driver-codes',
        component: () => import('@pages/cards/DriverCodes.vue'),
        meta: {
          label: 'side_nav.driver_codes',
          group: 'side-nav',
          user_type: ['@CLIENT', '@CARD'],
          cust_type: ['*'],
          permissions: ['CLI_DRIVER_CODE'],
          institutions: ['*'],
          icon: '/img/nav/driver_codes.svg',
        },
      },
      {
        name: 'contactless-limit',
        path: 'contactless-limit',
        component: () => import('@pages/cards/Contactless-limit.vue'),
        meta: {
          label: 'side_nav.contactless_limit',
          group: 'side-nav',
          user_type: ['@CARD'],
          cust_type: ['*'],
          permissions: ['CARD_CARD_LIMIT'],
          institutions: ['RUBISKE', 'GALANAMG'],
          icon: '/img/nav/driver_codes.svg',
        },
      },
    ],
  },
  {
    name: 'funds',
    path: '/funds',
    meta: {
      label: 'sub_nav.funds',
      group: 'sub-nav',
      ...(() => {
        const permissions = {
          permissions: ['*'],
          institutions: ['*'],
          user_type: ['@CLIENT', '@CARD'],
          cust_type: ['*'],
        }
        switch (institution) {
          case 'rwanda':
            return { ...permissions, user_type: ['@CLIENT'] }
          case 'kenya':
            return { ...permissions, cust_type: ['Prepaid'] }
          default:
            return permissions
        }
      })(),
      icon: '',
    },
    children: [
      {
        name: 'topups',
        path: 'topups',
        component: () => import('@pages/funds/Topups.vue'),
        meta: {
          label: 'side_nav.top_up',
          group: 'side-nav',
          user_type: ['@CLIENT', '@CARD'],
          cust_type: ['Prepaid'],
          permissions: ['*'],
          institutions: [
            'RUBISKE',
            'RUBISUG',
            'RUBISZM',
            'RUBISMG',
            'GALANAMG',
          ],
          icon: '/img/nav/top_up.svg',
        },
      },
      {
        name: 'card_to_card',
        path: 'cardToCard',
        component: () => import('@pages/funds/CardToCard.vue'),
        meta: {
          label: 'side_nav.card_to_card',
          group: 'side-nav',
          user_type: ['@CLIENT'],
          cust_type: ['*'],
          permissions: ['CLI_CARD_TO_CARD'],
          institutions: ['*'],
          icon: '/img/nav/card_to_card.svg',
        },
      },
      ,
      {
        name: 'card_to_card_auth',
        path: 'cardToCardAuth',
        component: () => import('@pages/funds/CardToCardAuth.vue'),
        meta: {
          label: 'side_nav.card_to_card_auth',
          group: 'side-nav',
          user_type: ['@CLIENT'],
          cust_type: ['*'],
          permissions: ['CLI_CARD_TO_CARD'],
          institutions: ['*'],
          icon: '/img/nav/card_to_card.svg',
        },
      },
    ],
  },
]

// Function to filter routes based on user access
export const generateRoutes = async (accountData) => {
  if (!accountData) return []

  const filterRoutes = (routes) => {
    return routes.filter((route) => {
      const hasPermission = hasAccess(route.meta, accountData)

      if (route.children) {
        route.children = filterRoutes(route.children)
        // If route has no accessible children and no component, remove it
        if (route.children.length === 0 && !route.component) {
          return false
        }

        route.redirect = { name: route.children[0].name }
      }

      return hasPermission
    })
  }

  return filterRoutes(BASE_MENUS)
}

// Export base menus for other uses
export const menus = BASE_MENUS
